import { AxiosResponse } from "axios";
import { ConversationLabel, ConversationTagGroup } from "frontend-lib/DomainTypes/Conversation";
import { useEffect, useState } from "react";

type Props = {
    api: {
        tagsGroups: () => {
            list: () => Promise<AxiosResponse>;
        };
        tags: () => {
            list: () => Promise<AxiosResponse>;
        };
    };
};

export default function useConvTags({
    api,
}: Props): [ConversationLabel[] | undefined, ConversationTagGroup[] | undefined, boolean, boolean] {
    const [convTags, setConvTags] = useState<ConversationLabel[]>();
    const [convTagGroups, setConvTagGroups] = useState<ConversationTagGroup[]>();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function loadTags() {
            setIsLoading(true);
            setIsError(false);
            try {
                const tagsGroupsPromise = api.tagsGroups().list();
                const tagsPromise = api.tags().list();

                const [tagsGroupsRes, tagsPromiseRes] = await Promise.all([
                    tagsGroupsPromise,
                    tagsPromise,
                ]);

                setConvTags(tagsPromiseRes.data?.conversationLabels);
                setConvTagGroups(tagsGroupsRes.data?.conversationLabelGroups);
            } catch {
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }
        loadTags();
    }, [api]);

    return [convTags, convTagGroups, isLoading, isError];
}
